import React, { useState} from "react";
import { Link } from "react-router-dom";
import { MenuData } from "./MenuData";
import SubMenu from "./SubMenu";
const Menu = () => {
  const [menubar, setMenubar] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const showMenubar = () =>{
    setMenubar(!menubar);
    if (!menubar) {
      document.body.style.cssText = "position: relative;width: calc(100% - 17px);overflow: hidden;touch-action: none;";
    } else {
      document.body.style.cssText = "";
    }
  } 
  window.addEventListener('resize', handleResize)
  function handleResize() {
    setScreenWidth(window.innerWidth)
  }
  return (
    <div  className="menu">
      <Link onClick={showMenubar} To="#" className="menuBars">
        <img className="img-fluid imgIcon" src="/images/menu.png" alt="" />
        <span>Menu</span>
      </Link>
        <div className={menubar ? "drawerMask open" : "drawerMask"} onClick={showMenubar}></div>
        <nav
          className={menubar ? "nav_menu active" : "nav_menu"}
          style={{
            backgroundImage: `url('/images/bgr_menu.png')`,
          }}
        >
          <div className="container">
            <div className="row nav_menu_items">
            {screenWidth > 1199 &&
                MenuData.slice(0, 7).map((item, index) => {
                  return (
                    <SubMenu item={item} key={index} showMenubar={showMenubar} />
                  );
                })}

            {screenWidth < 1199 &&
                MenuData.map((item, index) => {
                  return (
                    <SubMenu item={item} key={index} showMenubar={showMenubar} />
                  );
                })}
              <div className="col-lg-3 col-12 col-md-6 item_menu closeMenu">
                <a>
                  <div onClick={showMenubar}>
                    <img className="img-fluid" src="/images/close.png" alt="" />
                    Đóng
                  </div>
                </a>
              </div>
            </div>
          </div>
        </nav>
    </div>
  );
};

export default Menu;
